import Head from 'next/head'
import shopInfos from 'template/infos'
import { absoluteSeoUrl, seoDescription, seoText, seoTitle } from 'src/functions/seo'

interface SeoProps {
  title?: string
  description?: string
  canonical: string
  image?: string
  imageAlt?: string
  robots?: string
  type?: 'website' | 'product'
  keywords?: string
  appendSiteName?: boolean
}

/** One keyed set of page metadata overrides the shared shop defaults. */
const Seo = ({ title, description, canonical, image, imageAlt, robots,
  type = 'website', keywords, appendSiteName = true }: SeoProps) => {
  const pageTitle = appendSiteName ? seoTitle(title) : seoText(title) || shopInfos.title
  const pageDescription = seoDescription(description)
  const pageUrl = absoluteSeoUrl(canonical)
  const imageUrl = image ? absoluteSeoUrl(image) : undefined
  return <Head>
    <title>{pageTitle}</title>
    <meta name='description' content={pageDescription} key='description' />
    {keywords && <meta name='keywords' content={seoText(keywords)} key='keywords' />}
    <meta name='robots' content={robots || 'index, follow, max-image-preview:large'} key='robots' />
    <link rel='canonical' href={pageUrl} key='canonical' />
    <meta property='og:type' content={type} key='og:type' />
    <meta property='og:title' content={pageTitle} key='og:title' />
    <meta property='og:description' content={pageDescription} key='og:description' />
    <meta property='og:url' content={pageUrl} key='og:url' />
    <meta property='og:site_name' content={shopInfos.name} key='og:site_name' />
    <meta property='og:locale' content={shopInfos.locale || 'de_DE'} key='og:locale' />
    <meta name='twitter:card' content='summary_large_image' key='twitter:card' />
    <meta name='twitter:title' content={pageTitle} key='twitter:title' />
    <meta name='twitter:description' content={pageDescription} key='twitter:description' />
    {imageUrl && <meta property='og:image' content={imageUrl} key='og:image' />}
    {imageUrl && <meta name='twitter:image' content={imageUrl} key='twitter:image' />}
    {imageAlt && <meta property='og:image:alt' content={seoText(imageAlt)} key='og:image:alt' />}
    {imageAlt && <meta name='twitter:image:alt' content={seoText(imageAlt)} key='twitter:image:alt' />}
  </Head>
}

export default Seo
